import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  bigqueryGetOrderedHashtags,
} from '../../services/mp-service-v1-api-service';

const fetchTrendingHashtagsByLanguage = () => {
  const [ trendingHashtagsData, setTrendingHashtagsData ] = useState({ });
  const [ fetchData, setFetchData ] = useState(null);
  const {
    order,
    limit,
    languageCode,
    onOperationComplete,
  } = fetchData || {};

  const fetchTrendingHashtags = async () => {
    try {
      console.log(`Fetching trending hashtags: languageCode : ${languageCode}, limit: ${limit}`);
      setTrendingHashtagsData({
        isFetching: true,
        isError: false,
      });

      const trendingHashtagsApiResp =  await bigqueryGetOrderedHashtags({
        language_code: languageCode,
        order,
        limit,
      });

      const responseData = trendingHashtagsApiResp.data;
      let errorMsg = null;
      if(responseData.success) {
        console.log(`Fetching trending hashtags for language : ${languageCode} Success!!`);
      } else {
        console.log(`Fetching trending hashtags for language : ${languageCode} Failed!!`);
        errorMsg = `Error occurred while fetching trending hashtags for language ${languageCode}.`;
      }

      setTrendingHashtagsData({
        data: responseData.data && responseData.data.result,
        isFetching: false,
        isError: !responseData.success,
        errorMsg,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError: !responseData.success,
          errorMsg,
        });
      }
    } catch (err) {
      console.log(`Error while fetching trending hashtags for language : ${languageCode}. Error : ${err}`);
      const errorMsg = `Error occurred while fetching hashtags for language : ${languageCode}.`;
      setTrendingHashtagsData({
        data: null,
        isFetching: false,
        isError: true,
        errorMsg,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(fetchData)) {
      fetchTrendingHashtags();
    }
  }, [ fetchData ]);

  return [
    trendingHashtagsData,
    setFetchData,
  ];
};

export default fetchTrendingHashtagsByLanguage;
